import { FormField } from "@/components/FormEngine/types";

/**
 * Generic function to sort a Map by the numeric indexes of its keys
 */
export const sortMapByIndex = <T>(map: Map<number, T>): Array<[number, T]> =>
  Array.from(map.entries()).sort((a, b) => a[0] - b[0]);

/**
 * Generic function to sort an array of objects having an id with an index
 */
export const sortByIdIndex = <T extends { id: string }>(
  items: T[],
  prefix: string,
): void => {
  items.sort((a, b) => {
    const aIndex = parseInt(a.id.replace(prefix, ""), 10);
    const bIndex = parseInt(b.id.replace(prefix, ""), 10);

    return aIndex - bIndex;
  });
};

/**
 * Specific sorting for fields by row, col, then name
 */
export const sortFields = (fields: FormField[]): void => {
  fields.sort((fa, fb) => {
    const byRow = fa.row - fb.row;
    if (byRow !== 0) return byRow;

    const byCol = fa.col - fb.col;
    if (byCol !== 0) return byCol;

    return fa.name.localeCompare(fb.name);
  });
};
